export default __webpack_public_path__ + "static/media/dropbox-logo.5d81e6c9.png";